import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { QuillModule, QuillModules } from 'ngx-quill';

import { BaseFormControlDirective } from '../base-form-control.directive';
import { ControlWrapperComponent } from '../control-wrapper/control-wrapper.component';
import { QUILL_MODULES_CONFIG } from './rich-text.constant';
import { ControlHasRequiredPipe } from '../pipes/control-has-required.pipe';

@Component({
  selector: 'app-rich-text',
  templateUrl: 'rich-text.component.html',
  styleUrls: ['rich-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ControlWrapperComponent, ReactiveFormsModule, AsyncPipe, QuillModule, NgClass, ControlHasRequiredPipe],
})
export class RichTextComponent extends BaseFormControlDirective {

  public modules: QuillModules = QUILL_MODULES_CONFIG;
}
